module.exports = __webpack_public_path__ + "static/media/align_bottom_dark.3372f6c6.svg";